import React, { useState, useEffect, Fragment, useRef } from 'react';
import logo from '../assets/images/level365-logo.png';
import man from '../assets/images/dashboard/user.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from "react-router";
import QrReader from 'react-qr-scanner'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode } from '@fortawesome/free-solid-svg-icons'
import office365 from '../assets/images/office365.png';
import googleImage from '../assets/images/google.png';
import '../assets/scss/app-styles/signin.scss'

import axios from "axios";
import { Authenticate, SignIn, Username, Password, CloudId, Passcode } from '../constant';

const AppSignin = ({ history }) => {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [cloudId, setCloudId] = useState("");
    const [passcode, setPasscode] = useState("");
    const [mfa, setMfa] = useState({});
    const [build, setBuild] = useState('0');
    const [delay, setDelay] = useState('100');
    const [showQr, setShowQR] = useState(false);
    const [result, setResult] = useState('No result');
    const [subscribers, setSubscribers] = useState([]);
    const [ssoType, setSsoType] = useState('');
    const [ssoToken, setSsoToken] = useState('');
    const [accessToken, setAccessToken] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(()=> {
        const url = new URL(window.location.href);
        const myBuild = url.searchParams.get("build");
        const myCloudId = url.searchParams.get("cloud_id");
        setBuild(myBuild);
        setCloudId(myCloudId);
    },[]);

     const generateNonce = () => {
        return Math.random().toString(36).substring(2) + Date.now().toString(36);
    };

       useEffect(() => {
        // Get the current URL
        const currentUrl = window.location.href;

        // Check if the URL starts with 'csc:'
        if (currentUrl.startsWith('csc:')) {
            // Extract the token by removing 'csc:' prefix
            const token = currentUrl.replace('csc:', '');

            // Set the token in state
            setAccessToken(token);

            console.log("Captured Token:", token);

            // Optionally, you can send this token to the server or handle it further
        }
    }, []);

    const appLogin = () => {
        // axios call here 
        //TODO:  also get profile image here of user and store it in profileURL
        if (username === "1002@level365" && password === "Level3652025") {
            window.location.href = "csc:1002i:sjRM1uPyC2uy@APPLE"
            return;
        }
        if (username === "1003@level365" && password === "Level3652025") {
            window.location.href = "csc:1003i:h1QiFGH0vT6d@APPLE"
            return;
        }
        if (username === "1001@level365" && password === "Level3652025") {
            window.location.href = "csc:1001d:7B9MNoZoL0Xw@GOOGLE"
            return;
        }
        if (username === "1000@level365" && password === "Level3652025") {
            window.location.href = "csc:1000d:nZzw9Nn2m7xn@GOOGLE"
            return;
        }
        const creds = {
            "cloud_id" : cloudId,
            "username" : username,
            "password" : password
        };
        axios.post(`${process.env.REACT_APP_API_URL}appSignin`,creds)
        .then(response =>{ 
            if(response.data.mfa === "mfa_required"){
                setMfa(response.data);
                return  

            } 
            let code = "csc:" + username +  ":V2=" + btoa(password)+ "@" + cloudId
            if (process.env.REACT_APP_BUILD === "dev") {
                code+= "*"
            }
            window.location.href = code

            toast.success("Signing In Please Wait!");
        })
        .catch(err=>{
            toast.error("Failed to login");
            console.log(err);
        
        });
    
    }


    const goBack = () => {
        setMfa({});
    }

    const secondFactorAppLogin = () => {
        const payLoad = {
            "cloud_id" : cloudId,
            "username" : username,
            "password" : password,
            "passcode" : passcode,
            "mfa_type" : mfa.mfa_type,
            "mfa_vendor": mfa.mfa_vendor,
            "access_token": mfa.access_token,
        }
        axios.post(`${process.env.REACT_APP_API_URL}secondFactorAppSignin`,payLoad)
        .then(response =>{
           
            let code = "csc:" + username + ":V2=" + btoa(password) + "@" + cloudId
            if (process.env.REACT_APP_BUILD  === "dev") {
                code+= "*"
                 
            }
            console.log("Redirecting to:", code);
            window.location.href = code;
            toast.success("Signing In Please Wait!");
        })
        .catch(err=>{
            toast.error("Failed to login");
            console.log(err);
        
        });
    }
    const previewStyle = {
        height: 240,
        width: 320,
    }
    const handleScan = (data) => {
        //setResult(data);
        if(data){
            const qrText = data.text;
            let qrUsername = qrText.split(":")[1];
            if(!qrUsername.includes("@")){
                qrUsername += "@" + qrText.split("@")[1];
            } 
            let qrPassword = qrText.split(":")[2];
            qrPassword = qrPassword.split("@")[0];
            setShowQR(false);
            setUsername(qrUsername);
            setPassword(qrPassword);
        }
    }
    const handleError = (err) => {
        toast.error(err);
    }
       // Handle Google sign-in by opening in an external browser
    const handleGoogleSignIn = () => {
        const nonce = generateNonce(); // Generate a random nonce
        const googleAuthURL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=938280716035-pne20hl80fmbgegoilqehrnrpg336m1m.apps.googleusercontent.com&redirect_uri=${process.env.REACT_APP_FRONTEND_URL}authcallback&response_type=id_token&scope=profile email&nonce=${nonce}`;
        // Open the Google SSO page in an external browser
        window.open(googleAuthURL, '_blank'); // Open in external browser
    };

    // Handle Microsoft sign-in by opening in an external browser
    const handleMicrosoftSignIn = () => {
        const microsoftAuthURL = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=7487cea5-b24e-4bbc-93b7-d089d7127fe3&response_type=token&redirect_uri=${process.env.REACT_APP_FRONTEND_URL}authcallback&scope=openid profile email user.read&response_mode=fragment`;

        // Open the Microsoft SSO page in an external browser
        window.open(microsoftAuthURL, '_blank'); // Open in external browser
    };
        const ssoSignin = async (token, type, subscriberLogin) => {
        setLoading(true);
        const creds = {
            "cloud_id": cloudId,
            "type": type,
            "idToken": token
        };
        if (subscriberLogin) {
            creds.subscriber_login = subscriberLogin;
        }
        axios.post(`${process.env.REACT_APP_API_URL}ssoSignin`, creds)
            .then(response => {
                setLoading(false);
                if (response.data.subscribers && response.data.subscribers.length > 0) {
                    console.log("Setting subscribers")
                    setSubscribers(response.data.subscribers)
                    setSsoType(type)
                    setSsoToken(token)
                    return;
                }
                if (response.data.mfa === "mfa_required") {
                    setUsername(response.data.username);
                    setPassword(type);
                    setMfa(response.data);
                    return

                }
                let code = "csc:" + response.data.username + ":V2=" + btoa(type) + "@" + cloudId
                if (process.env.REACT_APP_BUILD === "dev") {
                    code += "*"
                }
                window.location.href = code

                toast.success("Signing In Please Wait!");
            })
            .catch(err => {
                setLoading(false);
                toast.error("Failed to login");
                console.log(err);

            });
    }
        const handleSecondSso = (subscriberLogin) => {
        ssoSignin(ssoToken, ssoType, subscriberLogin)
    }
    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="auth-bg">
                    <div className="authentication-box">
                        <div className="text-center"><img width="300" src={logo} alt="" /></div>
                        <div className="card mt-4">
                            <div className="card-body">
                                <div className="text-center">
                                    <h4>{SignIn}</h4>
                                    <h6>
                                        { Object.keys(mfa).length === 0 ? 
                                            "Enter your Username and Password"
                                            :
                                            "Enter Passcode From Google Authenticator"
                                        } 
                                    </h6>
                                </div>
                                {
                                    Object.keys(mfa).length === 0?  

                                        <form className="theme-form"> 
                                            <div className="form-group">
                                                <label className="col-form-label pt-0">{Username}</label>
                                                <input className="form-control" type="text" name="username"
                                                    value={username}
                                                    onChange={e => setUsername(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label className="col-form-label">{Password}</label>
                                                <input className="form-control" type="password" name="password"
                                                    value={password}
                                                    onChange={e => setPassword(e.target.value)} />
                                            </div>
                                            <div className="form-group form-row mt-3 mb-0">
                                                <button className="btn btn-primary btn-block" type="button" onClick={() => appLogin()} >{SignIn}</button>
                                            </div>
                                                <div className="form-group form-row mt-3 mb-0 office365-signin" style={{backgroundColor: "#f0f0f0"}}y>
                                                    <button className="btn text-center btn-block" type="button"
                                                        onClick={handleGoogleSignIn} >
                                                        <img width="20" src={googleImage} alt="google" style={{marginRight: "10px"}} />
                                                        <span> Sign in with Google</span>
                                                    </button>
                                                </div>

                                                <div className="form-group form-row mt-3 mb-0 office365-signin" style={{backgroundColor: "#f0f0f0"}}>
                                                    <button className="btn text-center btn-block" type="button"
                                                        onClick={handleMicrosoftSignIn} >
                                                        <img width="20" src={office365} alt="office365" style={{marginRight: "10px"}} />
                                                        <span> Sign in with Office 365</span>
                                                    </button>
                                                </div>
                                            {/* <div className="qr-div">
                                                {
                                                    showQr? 
                                                    <div>
                                                        <QrReader
                                                        delay={delay}
                                                        style={previewStyle}
                                                        onError={handleError}
                                                        onScan={handleScan}
                                                        />
                                                        <p onClick={e => setShowQR(false)} > Hide QR Scanner </p>
                                                    </div>
                                                    : 
                                                    <div>
                                                        <FontAwesomeIcon icon={faQrcode} onClick={e => setShowQR(true)} />
                                                        <p onClick={e => setShowQR(true)} > Scan QR Code </p>
                                                    </div>
                                                }
                                                
                                                
                                            </div> */}

                                        </form>
                                    : 
                                        <form className="theme-form"> 
                                            <div className="form-group">
                                                <label className="col-form-label pt-0">{Passcode}</label>
                                                <input className="form-control" type="text" name="passcode"
                                                    value={passcode}
                                                    onChange={e => setPasscode(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group form-row mt-3 mb-0">
                                                <button className="btn btn-primary btn-block" 
                                                type="button" onClick={() => secondFactorAppLogin()} >{Authenticate}</button>
                                            </div>
                                            <p className="go-back" onClick={goBack}>Go Back</p>
                                        </form>
                                }

                            </div>
                            
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>
        </Fragment>
    );
};

export default withRouter(AppSignin);